import { useMutation, useQueryClient } from '@tanstack/react-query'
import { baseUrl } from 'api/config'
import axios from 'axios'
import { useSnackbarContext } from '../../context/SnackbarProvider/SnackbarProvider'

const notifyApprovers = async payload => {
  const slackToken = localStorage.getItem('slack_access_token')
  if (!slackToken) {
    console.error('No authentication token available')
    return
  }

  try {
    const response = await axios.post(
      `${baseUrl}/aws/slack/notify/approvers`,
      payload, // Now directly sending JSON payload
      {
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          Authorization: slackToken,
        },
      }
    )
    return response.data
  } catch (error) {
    console.error('Error sending approver notification:', error)
    throw error // Re-throw the error for useMutation's onError to catch
  }
}

export const useNotifyApprovers = () => {
  const { showSnackbar } = useSnackbarContext()
  const queryClient = useQueryClient()
  const mutation = useMutation({
    // Directly pass the object to the mutation function
    mutationFn: notifyApprovers,
    onSuccess: data => {
      console.log('Message Sent Successfully: ', data)
      showSnackbar('Notification(s) sent successfully to approvers', 'success')
    },
    onError: error => {
      console.error('[useNotifyApprovers] Error sending message:', error)
      showSnackbar((error as any).response.data.message || error.message, 'error')
    },
  })

  return mutation
}
